import type { SocialContent } from '@mawkaa/types';
import { Facebook, Instagram, Twitter, Linkedin, Youtube, Globe } from 'lucide-react';

interface SocialBlockProps {
  content: SocialContent;
  isEditing?: boolean;
}

const socialIcons: Record<string, React.ComponentType<{ className?: string }>> = {
  facebook: Facebook,
  instagram: Instagram,
  twitter: Twitter,
  linkedin: Linkedin,
  youtube: Youtube,
  website: Globe,
};

export function SocialBlock({ content, isEditing }: SocialBlockProps) {
  const { title, subtitle, links = [], style = 'icons' } = content;

  const defaultLinks = [
    { platform: 'facebook', url: '#', label: 'Facebook' },
    { platform: 'instagram', url: '#', label: 'Instagram' },
    { platform: 'twitter', url: '#', label: 'Twitter' },
  ];

  const displayLinks = links.length > 0 ? links : defaultLinks;

  return (
    <section className="px-4 py-12">
      <div className="max-w-2xl mx-auto text-center">
        {title && <h2 className="text-2xl font-bold mb-2">{title}</h2>}
        {subtitle && <p className="text-muted-foreground mb-6">{subtitle}</p>}

        <div className={`flex justify-center gap-4 ${style === 'buttons' ? 'flex-wrap' : ''}`}>
          {displayLinks.map((link, index) => {
            const Icon = socialIcons[link.platform] || Globe;

            if (style === 'buttons') {
              return (
                <a
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-6 py-3 border rounded-full hover:bg-gray-50 transition-colors"
                >
                  <Icon className="w-5 h-5" />
                  <span>{link.label || link.platform}</span>
                </a>
              );
            }

            return (
              <a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 hover:bg-primary hover:text-white transition-colors"
                title={link.label || link.platform}
              >
                <Icon className="w-5 h-5" />
              </a>
            );
          })}
        </div>

        {isEditing && links.length === 0 && (
          <p className="text-muted-foreground text-sm mt-4">
            Configurez vos liens de réseaux sociaux
          </p>
        )}
      </div>
    </section>
  );
}
